<script>
//--------------------------------------------------
// imported classes
//--------------------------------------------------
import { DropdownMenu, DropdownItem, Row, Col } from 'vant'

//--------------------------------------------------
// global registration
//--------------------------------------------------

//--------------------------------------------------
// main script
//--------------------------------------------------
export default {
    //--------------------------------------------------
	// component extends
	//--------------------------------------------------

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-dropdown-menu': DropdownMenu,
        'van-dropdown-item': DropdownItem,
        'van-row': Row,
        'van-col': Col,
    },

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
	data() {
        return {
            summary: {
                seasons: [],
                leagues: [],
                groups: [],
                stats: {},
                rankings: [],
                season: null
            },
            filter: {
                season: '',
                league: '',
                group: '',
            },
            isLoading: true,
            locale: {}
        }
	},

    //--------------------------------------------------
    // component life cycle trigger
    //--------------------------------------------------

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        seasonOptions() {
            // console.log('seasonOptions', this.locale, this.summary.seasons)
            let options = []
            if (this.locale) {
                const defaultText = this.summary.season ? this.summary.season : this.locale['select-season-placeholder']
                options.push({text: defaultText, value: ''})
                if (this.summary.seasons.length) {
                    options = options.concat(this.summary.seasons)
                }
            }
            return options
        },
        leagueOptions() {
            let options = []
            if (this.locale) {
                options.push({text: this.locale['select-league-placeholder'], value: ''})
                if (this.summary.leagues.length) {
                    options = options.concat(this.summary.leagues)
                }
            }
            return options
        },
        groupOptions() {
            let options = []
            if (this.locale) {
                options.push({text: this.locale['select-group-placeholder'], value: ''})
                if (this.filter.season != '' && this.filter.league != '') {
                    options = options.concat(this.summary.groups)
                }
            }
            return options
        },
        playerStatsIndicators() {
            const indicators = []
            let level = 'career'
            if (this.summary.season) {
                level = 'season'
            }
            else if (this.filter.group) {
                level = 'group'
            }
            else if (this.filter.league && this.filter.season) {
                level = 'match'
            }
            else if (this.filter.league && !this.filter.season) {
                level = 'league'
            }
            else if (!this.filter.league && this.filter.season) {
                level = 'season'
            }
            for (let p in this.summary.stats) {
                const value = this.summary.stats[p]
                if (!value) {
                    continue
                }
                let rank
                for (let j = 0; j < this.summary.rankings.length; j++) {
                    let ranking = this.summary.rankings[j]
                    if (p == ranking.indicator) {
                        rank = ranking.rank
                        break
                    }
                }
                if (p == 'cgp') {
                    p = 'gp'
                }
                indicators.push({
                    prop: p.toUpperCase(),
                    label: this.locale.localeProp('stats-type-' + p),
                    value: value,
                    rank: rank ? this.locale.localeProp('level-rank', {level: level, rank: rank}) : '',
                })
            }
            return indicators
        }
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        //--------------------------------------------------
        // handler method
        //--------------------------------------------------
        onSeasonChange() {
            this.updateQuery()
        },
        onLeagueChange() {
            this.updateQuery()
        },
        onGroupChange() {
            this.updateQuery()
        },
        onSummaryClick() {
            if (!this.isPaidService()) {
                this.onServiceBtnClick()
            }
        },
        onServiceBtnClick() {
            // console.log('onServiceBtnClick')
            this.$emit('custom-event', {
                type: 'popup-service'
            })
        },

        //--------------------------------------------------
        // private method
        //--------------------------------------------------
        updateQuery() {
            this.$emit('custom-event', {
                type: 'updateQuery',
                data: {
                    query: {
                        season: this.filter.season,
                        league: this.filter.league,
                        group: this.filter.group,
                    },
                }
            })
        },
        isPaidService() {
            return this.summary.seasons.length > 0 ? true : false
        }
    }
}
</script>

<template>
    <!-- component -->
    <div class="report-summary" @click="onSummaryClick">
        <van-dropdown-menu>
            <van-dropdown-item 
                v-model="filter.season" 
                :options="seasonOptions"
                :disabled="!isPaidService()"
                @change="onSeasonChange"
            />
            <van-dropdown-item 
                v-model="filter.league" 
                :options="leagueOptions"
                :disabled="!isPaidService()"
                @change="onLeagueChange"
            />
            <van-dropdown-item 
                v-model="filter.group" 
                :options="groupOptions"
                :disabled="!isPaidService()"
                @change="onGroupChange"
            />
        </van-dropdown-menu>
        <div v-if="!isLoading">
            <van-row class="u-outer-padding t-outer-margin">
                <van-col v-for="item in playerStatsIndicators" span="6" :key="item.prop">
                    <div class="stats-unit b-outer-margin corner-round-sm text-center">
                        <span class="block huge-title t-outer-padding">{{ item.value }}</span>
                        <span class="block minor-text main-secondary-color">{{ item.prop }}</span>
                        <span class="block minor-text main-secondary-color">{{ item.label }}</span>
                        <span class="block minor-text ranking-unit color-white">{{ item.rank }}</span>
                    </div>
                </van-col>
            </van-row>
        </div>
        <!--
        <div v-else>
            <div class="service-unit justify-center">
                <div class="wm-wrapper">
                    <img src="@/fcl/assets/user/player-stats-summary-wm.jpg" style="width: 345px; height: 131px;"/>
                </div>
                <div class="float-layer absolute">
                    <div class="lock-wrapper text-center">
                        <img src="@/fcl/assets/user/lock-symbol.png" style="width: 39px; height: 39px;" />
                    </div>
                    <div class="prompt-hint text-center">
                        <span class="block text-title">{{ locale['launch-service'] }}</span>
                        <span class="block normal-text">{{ locale['player-stats-summary-feature'] }}</span>
                    </div>
                </div>
            </div>
            <div class="t-wide-margin l-wide-margin">
                <div class="service-button btn justify-center vertical-center" @click="onServiceBtnClick">
                    <span class="color-white text-title">{{ locale['data-service-launch'] }}</span>
                    <span class="l-outer-margin"><img src="@/fcl/assets/user/vip-symbol.png" style="height: 12px; width: 16px;"/></span>
                </div>
            </div>
        </div>
        -->
        <van-overlay 
            :show="isLoading" 
            class="vertical-center justify-center"
        >
            <van-loading />
        </van-overlay>
    </div>
</template>

<style scoped>
.stats-unit {
    background: #F2F3F5;
    height: 102px;
    margin-left: 3px;
    margin-right: 3px;
}
.ranking-unit {
    background: #C52020;
}
.service-unit {
    height: 180px;
}
.service-button {
    height: 45px;
    width: 346px;
    background: #E1671C;
}
.float-layer {
    margin-top: 86px;
}
</style>